import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { LineChart } from "@mui/x-charts/LineChart";
import { TeamContext } from "../component/context/TeamContext";
import apiUrl from "../config";
import allTeams from "../data/teams"; // Adjust the import path as necessary
import Skaters from "../component/leaders/skaters";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import AdBanner from "../component/ads/AdBanner";

export default function Leaders() {
  const [skaters, setSkaters] = useState<any>(null);
  const [goalies, setGoalies] = useState<any>(null);
  const [limit, setLimit] = useState<Number>(10);

  const fetchLeadersData = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/leaders/skaters/${limit}`,
      );
      setSkaters(response.data);

      const goalieResponse = await axios.get(
        `${apiUrl}/api/leaders/goalies/${limit}`,
      );
      setGoalies(goalieResponse.data);
    } catch (error) {
      console.error("Error fetching player stats:", error);
    }
  };

  useEffect(() => {
    fetchLeadersData();
  }, []);

  return (
    <div className="wrapper">
      <div className="main">
        <h1>NHL Leaders</h1>
        {!skaters ? (
          <Box sx={{ display: "flex", minHeight: "500px" }}>
            <CircularProgress />
          </Box>
        ) : (
          <div className="leaderWrapper">
            <div>
              <h3>Most Goals</h3>
              {skaters && <Skaters skaterData={skaters.goals} type={"Goals"} />}
            </div>
            <div>
              <h3>Goalies</h3>
              {goalies && (
                <Skaters skaterData={goalies.savePctg} type={"SV %"} />
              )}
            </div>
            <div>
              <h3>Most Points</h3>
              {skaters && (
                <Skaters skaterData={skaters.points} type={"Points"} />
              )}
            </div>
            <div>
              <h3>Most Assists</h3>
              {skaters && (
                <Skaters skaterData={skaters.assists} type={"Assists"} />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
